import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
export function App() {
  useEffect(() => {
    document.title = 'Paz Hormonal';
  }, []);
  return <div className="min-h-screen font-sans bg-brand-cream text-brand-charcoal selection:bg-brand-green/20 selection:text-brand-green" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <AgitationSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <OfferSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <ClosingSection data-id="element-12" />
      </main>
      <footer className="bg-brand-charcoal text-white/50 text-center py-6 text-sm border-t border-white/10" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} El Código Hormonal +40. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}